import React from 'react';

import blog11 from '../../assets/img/blog/blog_1_1.jpg';
import blog12 from '../../assets/img/blog/blog_1_2.jpg';
import blog13 from '../../assets/img/blog/blog_1_3.jpg';
import blog14 from '../../assets/img/blog/blog_1_3.jpg';
import footerbgshape3 from '../../assets/img/shape/footer-bg-shape3.png';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

const BlogArea = () => {
  return (
    <>

<section className="overflow-hidden space" id="blog-sec">
        {/* <div
          className="shape-mockup blog-bg-shape2-1 jump-reverse d-xl-block d-none"
          data-top="20%"
          data-right={0}
        >
          <img src={footerbgshape3} alt="Shape Background" />
        </div> */}
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title after-none before-none">
              News &amp; Articles
            </span>
            <h2 className="sec-title">Our Latest News &amp; Articles</h2>
          </div>
          <div className="slider-area">
            {/* Add any additional HTML content here */}
          </div>
        </div>
      </section>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={30}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
        }}
      >
        {[
          {
            date: "July 16, 2024",
            category: "Education",
            title: "See Your Impact: Transparent Donation Tracking",
            imgSrc: blog11,
          },
          {
            date: "March 24, 2024",
            category: "Education",
            title: "Every Contribution Counts: Make a Difference",
            imgSrc: blog12,
          },
          {
            date: "June 30, 2024",
            category: "Education",
            title: "Real Stories, Real Impact: Your Donations at Work",
            imgSrc: blog13,
          },
          {
            date: "June 30, 2023",
            category: "Education",
            title: "Real Stories, Real Impact: Your Donations at Work",
            imgSrc: blog14,
          },
        ].map((item, index) => (
          <SwiperSlide key={index}>
            <div className="blog-card">
              <div className="blog-img">
                <a href="blog-details.html">
                  <img src={item.imgSrc} alt="Blog" />
                </a>
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <a href="blog.html">
                    <i className="fas fa-calendar" /> {item.date}
                  </a>
                  <a href="blog.html">
                    <i className="fas fa-tags" /> {item.category}
                  </a>
                </div>
                <h3 className="box-title">
                  <a href="blog-details.html">{item.title}</a>
                </h3>
                <a href="blog-details.html" className="th-btn">
                  Read More <i className="fas fa-arrow-up-right ms-2" />
                </a>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Other Content */}
    
    </>
  );
};

export default BlogArea;
